import { render, staticRenderFns } from "./HappyGLogo.vue?vue&type=template&id=108d071d&lang=html&"
import script from "./HappyGLogo.vue?vue&type=script&lang=js&"
export * from "./HappyGLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports